import { initSubRoutes } from '../../../../utils/router';

const RoutesArmes = initSubRoutes({
    route: '/armes',
    subroutes: {},
    nom: 'Armes',
});

export default RoutesArmes;
